import { Divider, Group, IconButton, iconSizes, Stack, Text } from '@common/ui'
import { IconTrash } from '@common/ui/icons'
import { com } from '@eidu/web'
import { PermissionWithId } from '../input/PermissionsInput'
import actionLabel from '../../domain/permission/actionLabel'
import EntitySelectorPermission = com.eidu.entity.permission.EntitySelectorPermission
import EntityPathPermission = com.eidu.entity.permission.EntityPathPermission

type UnassignedPermissionsListProps = {
  permissions: readonly PermissionWithId[]
  onRemove: (id: string) => void
}

const UnassignedPermissionsList = ({ permissions, onRemove }: UnassignedPermissionsListProps) => {
  if (permissions.length === 0) return null
  return (
    <div
      style={{
        border: '1px solid var(--trellis-color-warning)',
        borderRadius: 'var(--trellis-radius-xs)',
        padding: 'var(--trellis-spacing-md)',
      }}
    >
      <Text size="sm" fw={600} mb="xxs">
        Other permissions ({permissions.length})
      </Text>
      <Text size="xs" c="dimmed">
        These permissions use targets that don&apos;t map to a single entity type row (e.g. <code>And</code>,{' '}
        <code>Or</code>, <code>Not</code>). They are kept on save but are not editable from the matrix above.
      </Text>
      <Divider my="xs" />
      <Stack gap="xxs">
        {permissions.map(({ id, permission }) => (
          <Group key={id} gap="xs" align="center" wrap="nowrap">
            <Text size="sm" style={{ flex: 1 }}>
              {actionLabel(permission.action)} —{' '}
              {permission instanceof EntitySelectorPermission
                ? permission.targets.toString()
                : permission instanceof EntityPathPermission
                  ? `path → ${permission.path.toType.toString()}`
                  : 'global'}
            </Text>
            <IconButton size="sm" onClick={() => onRemove(id)} aria-label="Remove">
              <IconTrash size={iconSizes.xs} stroke={1.5} />
            </IconButton>
          </Group>
        ))}
      </Stack>
    </div>
  )
}

export default UnassignedPermissionsList
